/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import {
  Grid,
  Typography,
} from '@mui/material';

import { useStyles } from './loading.styles';
import { useEnvStore } from '../../store/models';
import EcalLoading from '../components/ecalLoadingLottie';

function Loading (props) {
  const classes = useStyles({});

  const env = useEnvStore();
  const [loadProgress, setLoadProgress] = useState ({
    init : false ,
    progressLabel: 'Loading...',
  });

  useEffect(() => {
    setLoadProgress(env.loadProgress);
  }, [env.observed.loadProgress]);

  function renderBrandCover () {
    return (
      <div className={classes.brandCoverSpace}>
        <EcalLoading className={classes.brandCoverImage} />
        <Grid className={classes.loadingTextSpace}>
          <Typography className={classes.loadingText}>
            { loadProgress.message }
          </Typography>
          <Typography className={classes.loadingDots}>
            { loadProgress.dots }
          </Typography>
        </Grid>
       
      </div>
    ); 
  }

  return (
    <React.Fragment>
      <Grid container className={classes.container}>
        <div className={classes.spacer}> </div>
        { renderBrandCover() }
      </Grid>
    </React.Fragment>
  );
}

export default observer(Loading);
